export const fontSize = {
  "sys-xs": "0.75rem",
  "sys-sm": "0.875rem",
  "sys-base": "1rem",
  "sys-lg": "1.125rem",
  "sys-xl": "1.25rem",
  "sys-2xl": "1.5rem",
  "sys-3xl": "1.875rem",
  "sys-4xl": "2rem",
  "sys-5xl": "2.5rem",
  "sys-6xl": "3rem",
  "sys-7xl": "5rem",
  "sys-8xl": "6rem",
  "sys-9xl": "7.5rem",
};
